module.exports = __webpack_public_path__ + "img/gin.36a3e9a3.svg";